import { render } from "./UtilizationReportTab.vue?vue&type=template&id=c5247b88"
import script from "./UtilizationReportTab.vue?vue&type=script&lang=js"
export * from "./UtilizationReportTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__